import { gql } from 'graphql-request';

export const FETCH_TVSHOW_RELAVANT_CONTENTS_QUERY = gql`
  query (
    $id: ID!
    $country: String
    $translation: String
    $platform: String
    $collectionFilter: CollectionFilter!
  ) {
    tvShowRelatedContent(
      id: $id
      country: $country
      translation: $translation
      platform: $platform
    ) {
      id
      title
      originalTitle
      duration
      contentOwner
      businessType
      genres {
        id
        value
      }
      languages
      description
      assetType
      assetSubType
      releaseDate
      image {
        list
        cover
        sticker
        svodCover
      }
      actors
      ageRating
      audioLanguages
      subtitleLanguages
      eventLive
      tags
      billingType
      tier
      seoTitle
      slug
      webUrl
      rating
      video {
        url
        drmKey
        hlsUrl
        isDrm
      }
      relatedMovies {
        id
        title
        originalTitle
        tags
        position
        contents {
          ... on Movie {
            id
            title
            originalTitle
            duration
            contentOwner
            businessType
            genres {
              id
              value
            }
            languages
            description
            assetType
            assetSubType
            releaseDate
            image {
              list
              cover
              sticker
              svodCover
            }
            actors
            ageRating
            audioLanguages
            subtitleLanguages
            eventLive
            tags
            introStartTime
            introEndTime
            billingType
            tier
            playDate
            seoTitle
            slug
            webUrl
            rating
            playedDuration
            video {
              isDrm
              url
              hlsUrl
              drmKey
            }
            relatedContentIds {
              id
            }
          }
          ... on Episode {
            id
            title
            originalTitle
            duration
            contentOwner
            businessType
            genres {
              id
              value
            }
            languages
            description
            assetType
            assetSubType
            releaseDate
            image {
              list
              cover
              svodCover
              sticker
            }
            actors
            ageRating
            audioLanguages
            subtitleLanguages
            eventLive
            tags
            introStartTime
            introEndTime
            episodeNumber
            billingType
            tier
            playDate
            seoTitle
            slug
            webUrl
            rating
            playedDuration
            video {
              url
              hlsUrl
              drmKey
              isDrm
            }
            tvShow {
              id
              title
              assetSubType
              originalTitle
            }
          }
        }
        page
        size
        totalResults
      }
      relatedTvShows {
        id
        title
        originalTitle
        tags
        position
        contents {
          ... on Movie {
            id
            title
            originalTitle
            duration
            contentOwner
            businessType
            genres {
              id
              value
            }
            languages
            description
            assetType
            assetSubType
            releaseDate
            image {
              list
              cover
              sticker
              svodCover
            }
            actors
            ageRating
            audioLanguages
            subtitleLanguages
            eventLive
            tags
            introStartTime
            introEndTime
            billingType
            tier
            playDate
            seoTitle
            slug
            webUrl
            rating
            playedDuration
            video {
              isDrm
              url
              hlsUrl
              drmKey
            }
            relatedContentIds {
              id
            }
          }
          ... on Episode {
            id
            title
            originalTitle
            duration
            contentOwner
            businessType
            genres {
              id
              value
            }
            languages
            description
            assetType
            assetSubType
            releaseDate
            image {
              list
              cover
              svodCover
              sticker
            }
            actors
            ageRating
            audioLanguages
            subtitleLanguages
            eventLive
            tags
            introStartTime
            introEndTime
            episodeNumber
            billingType
            tier
            playDate
            seoTitle
            slug
            webUrl
            rating
            playedDuration
            video {
              url
              hlsUrl
              drmKey
              isDrm
            }
            tvShow {
              id
              title
              assetSubType
              originalTitle
            }
          }
        }
        page
        size
        totalResults
      }
      relatedChannels {
        id
        title
        originalTitle
        tags
        position
        contents {
          ... on Movie {
            id
            title
            originalTitle
            duration
            contentOwner
            businessType
            genres {
              id
              value
            }
            languages
            description
            assetType
            assetSubType
            releaseDate
            image {
              list
              cover
              sticker
              svodCover
            }
            actors
            ageRating
            audioLanguages
            subtitleLanguages
            eventLive
            tags
            introStartTime
            introEndTime
            billingType
            tier
            playDate
            seoTitle
            slug
            webUrl
            rating
            playedDuration
            video {
              isDrm
              url
              hlsUrl
              drmKey
            }
            relatedContentIds {
              id
            }
          }
          ... on Episode {
            id
            title
            originalTitle
            duration
            contentOwner
            businessType
            genres {
              id
              value
            }
            languages
            description
            assetType
            assetSubType
            releaseDate
            image {
              list
              cover
              svodCover
              sticker
            }
            actors
            ageRating
            audioLanguages
            subtitleLanguages
            eventLive
            tags
            introStartTime
            introEndTime
            episodeNumber
            billingType
            tier
            playDate
            seoTitle
            slug
            webUrl
            rating
            playedDuration
            video {
              url
              hlsUrl
              drmKey
              isDrm
            }
            tvShow {
              id
              title
              assetSubType
              originalTitle
            }
          }
        }
        page
        size
        totalResults
      }
      relatedVideos {
        id
        title
        originalTitle
        tags
        position
        contents {
          ... on Movie {
            id
            title
            originalTitle
            duration
            contentOwner
            businessType
            genres {
              id
              value
            }
            languages
            description
            assetType
            assetSubType
            releaseDate
            image {
              list
              cover
              sticker
              svodCover
            }
            actors
            ageRating
            audioLanguages
            subtitleLanguages
            eventLive
            tags
            introStartTime
            introEndTime
            billingType
            tier
            playDate
            seoTitle
            slug
            webUrl
            rating
            playedDuration
            video {
              isDrm
              url
              hlsUrl
              drmKey
            }
            relatedContentIds {
              id
            }
          }
          ... on Episode {
            id
            title
            originalTitle
            duration
            contentOwner
            businessType
            genres {
              id
              value
            }
            languages
            description
            assetType
            assetSubType
            releaseDate
            image {
              list
              cover
              svodCover
              sticker
            }
            actors
            ageRating
            audioLanguages
            subtitleLanguages
            eventLive
            tags
            introStartTime
            introEndTime
            episodeNumber
            billingType
            tier
            playDate
            seoTitle
            slug
            webUrl
            rating
            playedDuration
            video {
              url
              hlsUrl
              drmKey
              isDrm
            }
            tvShow {
              id
              title
              assetSubType
              originalTitle
            }
          }
        }
        page
        size
        totalResults
      }
      relatedCollections {
        title
        originalTitle
        collections(filter: $collectionFilter) {
          id
          title
          originalTitle
          tags
          rails {
            id
            title
            originalTitle
            tags
            position
            contents {
              ... on Movie {
                id
                title
                originalTitle
                duration
                contentOwner
                businessType
                genres {
                  id
                  value
                }
                languages
                description
                assetType
                assetSubType
                releaseDate
                image {
                  list
                  cover
                  sticker
                  svodCover
                }
                actors
                ageRating
                audioLanguages
                subtitleLanguages
                eventLive
                tags
                introStartTime
                introEndTime
                billingType
                tier
                playDate
                seoTitle
                slug
                webUrl
                rating
                playedDuration
                video {
                  isDrm
                  url
                  hlsUrl
                  drmKey
                }
                relatedContentIds {
                  id
                }
              }
              ... on Episode {
                id
                title
                originalTitle
                duration
                contentOwner
                businessType
                genres {
                  id
                  value
                }
                languages
                description
                assetType
                assetSubType
                releaseDate
                image {
                  list
                  cover
                  svodCover
                  sticker
                }
                actors
                ageRating
                audioLanguages
                subtitleLanguages
                eventLive
                tags
                introStartTime
                introEndTime
                episodeNumber
                billingType
                tier
                playDate
                seoTitle
                slug
                webUrl
                rating
                playedDuration
                video {
                  url
                  hlsUrl
                  drmKey
                  isDrm
                }
                tvShow {
                  id
                  title
                  assetSubType
                  originalTitle
                }
              }
            }
            page
            size
            totalResults
          }
          page
          size
          totalResults
        }
      }
      seasons {
        id
        title
        originalTitle
        duration
        contentOwner
        businessType
        genres {
          id
          value
        }
        languages
        description
        assetType
        assetSubType
        releaseDate
        image {
          list
          cover
        }
        actors
        ageRating
        audioLanguages
        subtitleLanguages
        eventLive
        tags
        billingType
        tier
        orderId
        clips {
          id
          title
          originalTitle
          duration
          contentOwner
          businessType
          genres {
            id
            value
          }
          languages
          description
          assetType
          assetSubType
          releaseDate
          image {
            list
            cover
          }
          actors
          ageRating
          audioLanguages
          subtitleLanguages
          eventLive
          tags
          introStartTime
          introEndTime
          episodeNumber
          billingType
          tier
          playDate
          seoTitle
          slug
          webUrl
          rating
          playedDuration
          video {
            url
            hlsUrl
            drmKey
            isDrm
          }
          tvShow {
            id
            title
            originalTitle
            assetSubType
          }
        }
        episodes {
          id
          title
          originalTitle
          duration
          contentOwner
          businessType
          genres {
            id
            value
          }
          languages
          description
          assetType
          assetSubType
          releaseDate
          image {
            list
            cover
          }
          actors
          ageRating
          audioLanguages
          subtitleLanguages
          eventLive
          tags
          introStartTime
          introEndTime
          episodeNumber
          billingType
          tier
          playDate
          seoTitle
          slug
          webUrl
          rating
          playedDuration
          video {
            url
            hlsUrl
            drmKey
            isDrm
          }
          tvShow {
            id
            title
            originalTitle
            assetSubType
          }
        }
        mobisodes {
          id
          title
          originalTitle
          duration
          contentOwner
          businessType
          genres {
            id
            value
          }
          languages
          description
          assetType
          assetSubType
          releaseDate
          image {
            list
            cover
          }
          actors
          ageRating
          audioLanguages
          subtitleLanguages
          eventLive
          tags
          introStartTime
          introEndTime
          episodeNumber
          billingType
          tier
          playDate
          seoTitle
          slug
          webUrl
          rating
          playedDuration
          video {
            url
            hlsUrl
            drmKey
            isDrm
          }
          tvShow {
            id
            title
            originalTitle
            assetSubType
          }
        }
        webisodes {
          id
          title
          originalTitle
          duration
          contentOwner
          businessType
          genres {
            id
            value
          }
          languages
          description
          assetType
          assetSubType
          releaseDate
          image {
            list
            cover
          }
          actors
          ageRating
          audioLanguages
          subtitleLanguages
          eventLive
          tags
          introStartTime
          introEndTime
          episodeNumber
          billingType
          tier
          playDate
          seoTitle
          slug
          webUrl
          rating
          playedDuration
          video {
            url
            hlsUrl
            drmKey
            isDrm
          }
          tvShow {
            id
            title
            originalTitle
            assetSubType
          }
        }
        previews {
          id
          title
          originalTitle
          duration
          contentOwner
          businessType
          genres {
            id
            value
          }
          languages
          description
          assetType
          assetSubType
          releaseDate
          image {
            list
            cover
          }
          actors
          ageRating
          audioLanguages
          subtitleLanguages
          eventLive
          tags
          introStartTime
          introEndTime
          episodeNumber
          billingType
          tier
          playDate
          seoTitle
          slug
          webUrl
          rating
          playedDuration
          video {
            url
            hlsUrl
            drmKey
            isDrm
          }
          tvShow {
            id
            title
            originalTitle
            assetSubType
          }
        }
        promos {
          id
          title
          originalTitle
          duration
          contentOwner
          businessType
          genres {
            id
            value
          }
          languages
          description
          assetType
          assetSubType
          releaseDate
          image {
            list
            cover
          }
          actors
          ageRating
          audioLanguages
          subtitleLanguages
          eventLive
          tags
          introStartTime
          introEndTime
          episodeNumber
          billingType
          tier
          playDate
          seoTitle
          slug
          webUrl
          rating
          playedDuration
          video {
            url
            hlsUrl
            drmKey
            isDrm
          }
          tvShow {
            id
            title
            originalTitle
            assetSubType
          }
        }
        teasers {
          id
          title
          originalTitle
          duration
          contentOwner
          businessType
          genres {
            id
            value
          }
          languages
          description
          assetType
          assetSubType
          releaseDate
          image {
            list
            cover
          }
          actors
          ageRating
          audioLanguages
          subtitleLanguages
          eventLive
          tags
          introStartTime
          introEndTime
          episodeNumber
          billingType
          tier
          playDate
          seoTitle
          slug
          webUrl
          rating
          playedDuration
          video {
            url
            hlsUrl
            drmKey
            isDrm
          }
          tvShow {
            id
            title
            originalTitle
            assetSubType
          }
        }
        trailers {
          id
          title
          originalTitle
          duration
          contentOwner
          businessType
          genres {
            id
            value
          }
          languages
          description
          assetType
          assetSubType
          releaseDate
          image {
            list
            cover
          }
          actors
          ageRating
          audioLanguages
          subtitleLanguages
          eventLive
          tags
          introStartTime
          introEndTime
          episodeNumber
          billingType
          tier
          playDate
          seoTitle
          slug
          webUrl
          rating
          playedDuration
          video {
            url
            hlsUrl
            drmKey
            isDrm
          }
          tvShow {
            id
            title
            originalTitle
            assetSubType
          }
        }
        samplePremiums {
          id
          title
          originalTitle
          duration
          contentOwner
          businessType
          genres {
            id
            value
          }
          languages
          description
          assetType
          assetSubType
          releaseDate
          image {
            list
            cover
          }
          actors
          ageRating
          audioLanguages
          subtitleLanguages
          eventLive
          tags
          introStartTime
          introEndTime
          episodeNumber
          billingType
          tier
          playDate
          seoTitle
          slug
          webUrl
          rating
          playedDuration
          video {
            url
            hlsUrl
            drmKey
            isDrm
          }
          tvShow {
            id
            title
            originalTitle
            assetSubType
          }
        }
        totalClips
        totalEpisodes
        totalMobisodes
        totalPreviews
        totalPromos
        totalSamplePremiums
        totalTeasers
        totalTrailers
        totalWebisodes
      }
    }
  }
`;
